<script>
    import Loader from '../Utilities/Loader.svelte';
    import {getObjects} from '../lib/data.js';
    import Field from '../Forms/Field.svelte';

    let folders;
    let selected;
    let report_id;

    async function get_folders() {
        folders = await getObjects("nessus_scans");
    }

    get_folders();
</script>

<style>
    .delete {
        margin-right: 20px;
        margin-top: 4px;
    }

    p {
        margin: 10px 0;
    }
</style>

<Loader obj={folders}>
    <div class="columns">
        <div class="column is-2">
            <div class="menu">
                <p class="menu-label">Shotgun</p>
                {#each folders as folder}
                <ul class="menu-list">
                    <li>
                        <p class="pointer" on:click={() => folder.expanded = !folder.expanded}>
                            <i class="icon fas pointer" class:fa-caret-down={folder.expanded} class:fa-caret-right={!folder.expanded}></i>
                            {folder.name}
                        </p>
                        {#if folder.expanded}
                        <ul class="menu-list">
                            {#each folder.scans as scan}
                            <li><span class="link" on:click={() => selected = scan}>{scan.name}</span></li>
                            {/each}
                        </ul>
                        {/if}
                    </li>
                </ul>
                {/each}
            </div>
        </div>
        <div class="column">
            <form action="/api/nessus/scans/{selected ? selected.id: ""}" method="POST" enctype="multipart/form-data" target="_blank">
                {#if selected}
                    <strong>Selected Report: </strong>
                    <p>
                        <span class="delete" on:click={() => selected = undefined }></span>
                        {selected.name}
                    </p>
                {:else}
                    <Field name="nessus_file" type="file" label="Nessus File" required />
                {/if}
                <Field label="Client Name" value={selected ? selected.name : ""} type="text" placeholder="Client Name" name="client_name" />
                <Field label="Matter Number" type="text" placeholder="Matter Number" name="matter_number" />
                <Field label="Report Name" type="text" placeholder="Report Name" name="report_name" />
                <div class="field">
                    <div class="control">
                        <label class="checkbox">
                        <input type="checkbox" name="privileged" value="1">
                            Privileged
                        </label>
                    </div>
                </div>
                <div class="buttons is-pulled-right">
                    <button class="button is-success">Submit</button>
                </div>
            </form>
        </div>
    </div>
</Loader>
